export default __webpack_public_path__ + "static/media/cookie6part2.3f1d8f82.svg";